import { ChapterTitleHeaderProps } from './types';

export const ChapterTitleHeader = ({ chapterHeader }: ChapterTitleHeaderProps) => <th className="px-2 pb-4 text-sm text-left">{chapterHeader}</th>;
